<div class="tilelayout-wrapper">
  <kendo-tilelayout
    [columns]="2"
    [style.width]="'100%'"
    [reorderable]="false"
    (reorder)="onReorder($event)"
    class="left-layout"
  >
    <kendo-tilelayout-item
      *ngFor="let item of firstLayoutItems; let i = index"
      [style.height]="item.height"
    >
      <kendo-tilelayout-item-header>
        <div class="header-container flex justify-between">
          <h5 class="header-text">{{ item.title }}</h5>
          <div class="refresh-container flex items-center gap-2">
            <span *ngIf="lastRefreshed['first-' + i]" class="last-refresh-time">
              Last Refresh: {{ lastRefreshed['first-' + i] }}
            </span>
            <button
              class="refresh-button"
              title="Refresh"
              (click)="refreshComponent(i, 'first')"
            >
              <img src="/assets/home/refresh-tile-icon.svg" />
            </button>
          </div>
        </div>
      </kendo-tilelayout-item-header>
      <kendo-tilelayout-item-body>
        <ng-container *ngIf="!refreshing[i]?.['first']">
          <ng-container *ngComponentOutlet="item.component"></ng-container>
        </ng-container>
      </kendo-tilelayout-item-body>
    </kendo-tilelayout-item>
  </kendo-tilelayout>

  <kendo-tilelayout
    [columns]="2"
    [style.width]="'100%'"
    [reorderable]="false"
    (reorder)="onReorder($event)"
    class="right-layout"
  >
    <kendo-tilelayout-item
      *ngFor="let item of secondLayoutItems; let i = index"
      [style.height]="item.height"
    >
      <kendo-tilelayout-item-header>
        <div class="header-container flex justify-between">
          <h5 class="header-text">{{ item.title }}</h5>
          <div class="refresh-container flex items-center gap-2">
            <span *ngIf="lastRefreshed['second-' + i]" class="last-refresh-time">
              Last Refresh: {{ lastRefreshed['second-' + i] }}
            </span>
            <button
              class="refresh-button"
              title="Refresh"
              (click)="refreshComponent(i, 'second')"
            >
              <img src="/assets/home/refresh-tile-icon.svg" />
            </button>
          </div>
        </div>
      </kendo-tilelayout-item-header>
      <kendo-tilelayout-item-body>
        <ng-container *ngIf="!refreshing[i]?.['second']">
          <ng-container *ngComponentOutlet="item.component"></ng-container>
        </ng-container>
      </kendo-tilelayout-item-body>
    </kendo-tilelayout-item>
  </kendo-tilelayout>
</div>
